import React from 'react';

import {
  UserAuthHandlerMachineSendType,
  UserAuthHandlerMachineStateType
} from '@nw/client-auth-manager';

import LandingSectionDM from '../Common/LandingSectionDM';

interface LoginPageProps {
  onSuccessfulLogin: (
    userAuthHandlerMachineState: UserAuthHandlerMachineStateType
  ) => void;
  onFailedLogin: () => void;
  localConfig: any;
  shouldCallUserProfileDetails: boolean;
  userAuthHandlerMachineState: UserAuthHandlerMachineStateType;
  userAuthHandlerMachineSend: UserAuthHandlerMachineSendType;
}

const DmLoginPageInterface: React.FC<LoginPageProps> = ({
  onSuccessfulLogin,
  userAuthHandlerMachineState,
  userAuthHandlerMachineSend
}) => {
  const renderHeroSection = () => (
    <>
      <LandingSectionDM
        onSuccessfulLogin={onSuccessfulLogin}
        userAuthHandlerMachineState={userAuthHandlerMachineState}
        userAuthHandlerMachineSend={userAuthHandlerMachineSend}
      />
    </>
  );

  return <>{renderHeroSection()}</>;
};

export default DmLoginPageInterface;
